import { useRouter } from 'next/router'
import Link from 'next/link'
import imageUrlBuilder from '@sanity/image-url'
import client from '@lib/sanity'
import Image from 'next/image'
import TextTruncate from 'react-text-truncate'
import { toPlainText } from '@portabletext/react'

const TeamMemberCard = ({ item }) => {
  const { locale } = useRouter()

  return (
    <div>
      {item.mainImage && (
        <div className="mb-4 shrink-0 md:basis-1/3">
          <Link href="/team/[slug]" as={`/team/${item.slug.current}`}>
            <a className="block font-medium">
              <div className="relative mx-auto aspect-square w-full border border-primary-200">
                <Image
                  src={imageUrlBuilder(client)
                    .image(item.mainImage)
                    .width(320)
                    .url()}
                  alt={item.name}
                  layout="fill"
                  objectFit="cover"
                  objectPosition="center"
                />
              </div>
            </a>
          </Link>
        </div>
      )}
      <h3 className="text-xl font-medium">
        <Link href="/team/[slug]" as={`/team/${item.slug.current}`}>
          <a>{item.name}</a>
        </Link>
      </h3>
      <p className="mb-4 text-primary-300">
        {item.role[locale] || item.role.en}
      </p>
      {item.bio.en && (
        <TextTruncate
          line={5}
          element="div"
          truncateText="…"
          text={toPlainText(
            item.bio[locale] && item.bio[locale].length
              ? item.bio[locale]
              : item.bio['en']
          )}
        />
      )}
    </div>
  )
}
export default TeamMemberCard
